export default "__VITE_ASSET__CPgCLfpo__"